const rawBase = (process.env.PUBLIC_URL || '').trim();
const APP_BASE = rawBase === '.' ? '' : rawBase.replace(/\/+$/, '');

export const publicAsset = (path = '') => {
  const normalizedPath = String(path).replace(/^\/+/, '');
  return normalizedPath ? `${APP_BASE}/${normalizedPath}` : APP_BASE || '/';
};

export const appBase = APP_BASE;
